"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hls = _interopRequireDefault(require("hls.js"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _ToastManager = require("../components/Toast/ToastManager");
var _HLSController = require("../controllers/hls/HLSController");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["payload"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var HLSVideo = (0, _reactUi.styled)("video", {
  margin: "0 auto",
  flex: "1 1 0",
  minHeight: 0,
  h: "100%"
});
var hlsController;
var HLSView = function HLSView() {
  var _hlsState$variants$;
  var videoRef = (0, _react.useRef)(null);
  var hlsState = (0, _reactSdk.useHMSStore)(_reactSdk.selectHLSState);
  var hlsUrl = (_hlsState$variants$ = hlsState.variants[0]) === null || _hlsState$variants$ === void 0 ? void 0 : _hlsState$variants$.url;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    availableLevels = _useState2[0],
    setAvailableLevels = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isVideoLive = _useState4[0],
    setIsVideoLive = _useState4[1];
  var _useState5 = (0, _react.useState)(""),
    _useState6 = _slicedToArray(_useState5, 2),
    currentSelectedQualityText = _useState6[0],
    setCurrentSelectedQualityText = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    qualityDropDownOpen = _useState8[0],
    setQualityDropDownOpen = _useState8[1];
  (0, _react.useEffect)(function () {
    if (videoRef.current && hlsUrl) {
      if (_hls["default"].isSupported()) {
        hlsController = new _HLSController.HLSController(hlsUrl, videoRef);
        hlsController.on(_HLSController.HLS_STREAM_NO_LONGER_LIVE, function () {
          setIsVideoLive(false);
        });
        hlsController.on(_HLSController.HLS_TIMED_METADATA_LOADED, function (_ref) {
          var payload = _ref.payload,
            rest = _objectWithoutProperties(_ref, _excluded);
          console.log("%c Payload: ".concat(payload), "color:#2b2d42; background:#d80032");
          console.log(rest);
          _ToastManager.ToastManager.addToast({
            title: "Payload from timed Metadata ".concat(payload)
          });
        });
        hlsController.on(_hls["default"].Events.MANIFEST_LOADED, function (_, _ref2) {
          var levels = _ref2.levels;
          var onlyVideoLevels = removeAudioLevels(levels);
          setAvailableLevels(onlyVideoLevels);
          setCurrentSelectedQualityText("Auto");
        });
      } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
        videoRef.current.src = hlsUrl;
      }
    }
  }, [hlsUrl]);
  (0, _react.useEffect)(function () {
    if (hlsController) {
      return function () {
        return hlsController.reset();
      };
    }
  }, []);
  var qualitySelectorHandler = (0, _react.useCallback)(function (qualityLevel) {
    if (hlsController) {
      hlsController.setCurrentLevel(qualityLevel);
      var levelText = qualityLevel.height === "auto" ? "Auto" : "".concat(qualityLevel.height, "p");
      setCurrentSelectedQualityText(levelText);
    }
  }, [availableLevels] //eslint-disable-line
  );

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
    children: hlsUrl ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      css: {
        flexDirection: "column",
        size: "100%",
        px: "$10"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(HLSVideo, {
        ref: videoRef,
        autoPlay: true,
        controls: true,
        playsInline: true
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
        align: "center",
        justify: "end",
        children: [hlsController ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Button, {
          variant: "standard",
          css: {
            marginRight: "0.3rem"
          },
          onClick: function onClick() {
            hlsController.jumpToLive();
            setIsVideoLive(true);
          },
          "data-testid": "leave_room_btn",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
            title: "Jump to Live",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
              css: {
                gap: "$2"
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.RecordIcon, {
                color: isVideoLive ? "#CC525F" : "FAFAFA"
              }, "jumpToLive"), "Live"]
            })
          })
        }, "LeaveRoom") : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Root, {
          open: qualityDropDownOpen,
          onOpenChange: function onOpenChange(value) {
            return setQualityDropDownOpen(value);
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Trigger, {
            asChild: true,
            "data-testid": "quality_selector",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
              css: {
                color: "$textPrimary",
                borderRadius: "$1",
                cursor: "pointer",
                zIndex: 4,
                border: "$space$px solid $textDisabled",
                padding: "$4"
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
                title: "Select Quality",
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.SettingsIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
                    variant: "md",
                    children: currentSelectedQualityText
                  })]
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
                css: {
                  "@lg": {
                    display: "none"
                  },
                  color: "$textDisabled"
                },
                children: qualityDropDownOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronDownIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronUpIcon, {})
              })]
            })
          }), availableLevels.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Content, {
            sideOffset: 5,
            align: "end",
            css: {
              height: "auto",
              maxHeight: "$96"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Item, {
              onClick: function onClick(event) {
                return qualitySelectorHandler({
                  height: "auto"
                });
              },
              css: {
                h: "auto",
                flexDirection: "column",
                flexWrap: "wrap",
                cursor: "pointer",
                alignItems: "flex-start"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
                children: "Automatic"
              })
            }, "auto"), availableLevels.map(function (level) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Item, {
                onClick: function onClick() {
                  return qualitySelectorHandler(level);
                },
                css: {
                  h: "auto",
                  flexDirection: "column",
                  flexWrap: "wrap",
                  cursor: "pointer",
                  alignItems: "flex-start"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
                  children: "".concat(level.height, "p (").concat((Number(level.bitrate / 1024) / 1024).toFixed(2), " Mbps)")
                })
              }, level.url);
            })]
          })]
        })]
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
      align: "center",
      justify: "center",
      css: {
        size: "100%",
        px: "$10"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        variant: "md",
        css: {
          textAlign: "center"
        },
        children: "Waiting for the stream to start..."
      })
    })
  });
};

/**
 *
 * This function is needed because HLSJS currently doesn't
 * support switching to audio rendition from a video rendition.
 * more on this here
 * https://github.com/video-dev/hls.js/issues/4881
 * https://github.com/video-dev/hls.js/issues/3480#issuecomment-778799541
 * https://github.com/video-dev/hls.js/issues/163#issuecomment-169773788
 *
 * @param {Array} levels array from hlsJS
 * @returns a new array with only video levels.
 */
function removeAudioLevels(levels) {
  return levels.filter(function (_ref3) {
    var videoCodec = _ref3.videoCodec,
      width = _ref3.width,
      height = _ref3.height;
    return !!videoCodec || !!(width && height);
  });
}
var _default = HLSView;
exports["default"] = _default;